import Listing from "../components/Listing";

export const ListingRouter = Listing;
